import { render, staticRenderFns } from "./DocumentDatasetStatus.vue?vue&type=template&id=0f78e7ca&scoped=true&"
import script from "./DocumentDatasetStatus.vue?vue&type=script&lang=js&"
export * from "./DocumentDatasetStatus.vue?vue&type=script&lang=js&"
import style0 from "../../assets/scss/document_dataset_status.scss?vue&type=style&index=0&id=0f78e7ca&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f78e7ca",
  null
  
)

export default component.exports